import { FC, ChangeEvent } from "react"
import Cell from "../Cell"
import TextField from "../TextField"
import { fieldConfig } from "@/pages/ControlPanel/config"
import { CustomerForm } from "@/types/customer"
import { isUndefined } from "@/utils/lodash"

interface NameFieldsProps {
   customerName: string
   facilityName: string
   onCustomerNameChange: (e: ChangeEvent<HTMLInputElement>) => void
   onFacilityNameChange: (e: ChangeEvent<HTMLInputElement>) => void
   isCustomerNameValid?: boolean
   isFacilityNameValid?: boolean
}

const NameFields: FC<NameFieldsProps> = ({
   customerName,
   facilityName,
   onCustomerNameChange,
   onFacilityNameChange,
   isCustomerNameValid,
   isFacilityNameValid,
}) => (
   <>
      <span className="customers-facilities-table__customer-name">
         <Cell
            name={"customerName" as keyof CustomerForm}
            value={customerName}
            isEditMode
            handleCellChange={onCustomerNameChange}
            placeholder={fieldConfig.customerName?.placeholder}
            {...(customerName !== "" && {
               error: !isUndefined(isCustomerNameValid) && !isCustomerNameValid,
            })}
         >
            {customerName || "-"}
         </Cell>
      </span>
      <span className="customers-facilities-table__name">
         <Cell
            name={"name" as keyof CustomerForm["facility"]}
            value={facilityName}
            isEditMode
            handleCellChange={onFacilityNameChange}
            placeholder={fieldConfig.name?.placeholder}
            {...(facilityName !== "" && {
               error: !isUndefined(isFacilityNameValid) && !isFacilityNameValid,
            })}
         >
            <TextField name="name">{facilityName}</TextField>
         </Cell>
      </span>
   </>
)

export default NameFields
